import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.Auth.ProfileSetup.Email.PreAhaMoment', {
    description8: 'Stay informed with email notifications and approve from your inbox',
    description15: 'Submit and approve documents on-the-go using the mobile app',
    description16: 'Monitor the approval process with built-in and custom reports',
    description2: 'Use Auto-Approvals for recurring monthly expenses to save time',
    description12: 'Create purchase orders and match bills for better spend control',
    description3: 'Verify suppliers with contact approvals before ordering',
    description11: 'View budgets alongside documents to prevent overspending',
    description16Path2: 'Track the approval process with built-in and custom reports',
    description4: 'Be audit-ready with auto-generated reports and auditor access',
    description18: 'Run and approve purchase orders for better spend control',
});
